import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Router } from '@angular/router';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { IApplicant } from 'src/app/model/IApplicant';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-admitted-applicant-layout',
  templateUrl: './admitted-applicant-layout.component.html',
  styleUrls: ['./admitted-applicant-layout.component.css']
})
export class AdmittedApplicantLayoutComponent implements OnInit {
  applicant: IApplicant;
  academicYear: string;

  constructor(private authService:AuthService,private utilService: UtilService,private router:Router,private cookieLocal:CookiesLocalService) { }

  ngOnInit() {
    this.applicant=this.cookieLocal.getApplicantData();

    this.utilService.getSystemConfig().subscribe(val => {


      // console.log(val);
      let upperNumber = val.ShowAdmittedBatchYearGroup + 1;

      this.academicYear = val.ShowAdmittedBatchYearGroup + '/' + upperNumber;
      // if (val.ShowAdmittedBactch === 1) {
      //   this.batchName = 'FIRST BATCH RELEASED';
      // } else {
      //   this.batchName = 'SECOND BATCH RELEASED';
      // }

    });




  }
  onLogout(e){
    e.preventDefault()
    if(this.applicant){
      this.authService.logout();
    }
    this.router.navigate(['/account/login']);

  }

}
